<template>
  <v-app class="admin-admin" id="inspire">
    <v-navigation-drawer width="220" stateless permanent clipped hide-overlay app :mini-variant.sync="drawerMini">
      <v-list dense>
        <v-list-group v-model="m.sel" v-for="m in menus" :key="m.id || m.l" :prepend-icon="m.i">
          <template v-slot:activator>
            <v-list-tile class="group">
              <v-list-tile-content>
                <v-list-tile-title>{{ m.l }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <div v-show="!drawerMini">
            <v-list-tile append v-model="c.sel" class="group-item" v-for="c in m.c" :key="c.url" :to="c.url">
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-icon small>{{ c.i }}</v-icon>
                  {{ c.l }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </div>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dark color="primary" app fixed clipped-left>
      <img v-if="tenant.logo" class="logo" :src="tenant.logo" @click="drawerMini = !drawerMini" />
      <img v-else class="logo" src="@/assets/logo-w.png" @click="drawerMini = !drawerMini" />
      <v-toolbar-title style="margin-left: 15px">
        {{
          !account.orgId
            ? tenant.appName || account.orgName || appname
            : account.orgName || appname
        }}
        <small v-if="!account.orgName">{{ slogan }}</small>
      </v-toolbar-title>
      <span class="top-acts acc-online-count" @click="refreshAccOnlineCount" v-if="accOnlineCount >= 0">
        <v-icon small>person_outline</v-icon><b>{{ accOnlineCount }}</b>人在线
      </span>
      <span v-if="isSuperMan" class="top-acts" @click="clearCache">
        <v-icon small>sync_disabled</v-icon>清除缓存
      </span>
      <span class="top-acts my-notifications" @click="showRightDrawer('notificationShow')">
        <v-icon small>notifications_none</v-icon>我的通知<template v-if="notificationCount.total > 0">(<b>{{
          notificationCount.unRead
            }}</b>)</template>
      </span>
      <v-spacer />
      <v-btn v-if="account.orgType == 1 && account.openAppStore" small depressed flat
        to="/console/home/admin/my/module">
        <v-icon small style="padding-right: 4px">lightbulb_outline</v-icon>应用超市
      </v-btn>
      <v-menu v-if="account &&
        account.type == 1 &&
        account.tenantId != 0 &&
        (account.originOrgId != account.orgId ||
          (moreOrgs && moreOrgs.length > 0))
      " offset-y max-height="300" min-width="100">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="origin-select px-1" style="line-height: 40px">
            <span class="ml-1">切换机构</span>
            <v-icon class="ml-1" style="cursor: pointer">expand_more</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-tile v-if="account.originOrgId != account.orgId" @click="changeOrg(account.originOrgId)">
            <v-list-tile-content>
              <v-list-tile-title>自己机构</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="account.tenantId != 0 &&
            account.originOrgId != account.orgId &&
            account.parentOrgId != account.orgId
          " @click="changeOrg(account.parentOrgId)">
            <v-list-tile-content>
              <v-list-tile-title>上一级机构</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-for="org in moreOrgs" :key="org.id" @click="changeOrg(org.id)">
            <v-list-tile-content>
              <v-list-tile-title>{{ org.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y v-if="account && account.type == 1 && account.tenantId">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="origin-select px-1" style="line-height: 40px">
            <span class="ml-1">资源搜索</span>
            <v-icon class="ml-1" style="cursor: pointer">expand_more</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-tile @click="searchResource(1)">
            <v-list-tile-content>
              <v-list-tile-title>视频</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>video_library</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="searchResource(2)">
            <v-list-tile-content>
              <v-list-tile-title>课件</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>playlist_play</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="searchResource(3)">
            <v-list-tile-content>
              <v-list-tile-title>题目</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>question_answer</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="searchResource(4)">
            <v-list-tile-content>
              <v-list-tile-title>试卷</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>book</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="searchResource(5)">
            <v-list-tile-content>
              <v-list-tile-title>阅读</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>insert_drive_file</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="searchResource(6)">
            <v-list-tile-content>
              <v-list-tile-title>培训方案</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>calendar_today</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <div v-on="on" class="user-avatar">
            <v-avatar size="40">
              <img v-if="avatarUrl" :src="avatarUrl" alt="avatar" />
            </v-avatar>
            <span class="ml-2">{{ account.nick || account.name }}</span>
            <v-icon class="ml-1" style="cursor: pointer">expand_more</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-tile @click="myFavorite" v-if="account && account.type == 1">
            <v-list-tile-content>
              <v-list-tile-title>我的收藏</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>favorite_border</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="myAccount">
            <v-list-tile-content>
              <v-list-tile-title>账号信息</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>perm_identity</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="myTask">
            <v-list-tile-content>
              <v-list-tile-title>异步任务</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>computer</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="regionBrowse">
            <v-list-tile-content>
              <v-list-tile-title>行政区划编码表</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>add_location</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-if="account.originTenantId === 0 &&
            account.tenantId != account.originTenantId
          " @click="changeToSuper">
            <v-list-tile-content>
              <v-list-tile-title>退出切换</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-content>
              <v-list-tile-title>退出登录</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="logout(true)">
            <v-list-tile-content>
              <v-list-tile-title>清除自动登录信息并退出</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>visibility_off</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content class="main-content" app>
      <v-layout column fill-height>
        <div class="breadcrumbs-container">
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="{ item }">
              <span v-if="item.disabled" class="grey--text">{{
                item.text
                }}</span>
              <router-link :class="{ disabled: item.disabled }" class="v-breadcrumbs__item" v-else-if="item.link"
                :to="item.link">{{ item.text }}</router-link>
              <a class="v-breadcrumbs__item" v-else>{{ item.text }}</a>
            </template>
          </v-breadcrumbs>
          <div class="back-link" v-if="breadcrumbs.length > 2" @click="$router.back()">
            <v-icon>arrow_upward</v-icon>返回上级
          </div>
        </div>
        <v-container id="main-container" fluid>
          <v-snackbar v-model="alert.show" right bottom :color="alert.type || 'error'" dark :timeout="5000"
            :auto-height="true">
            <div class="status" v-if="alert.msg">
              <p v-for="p in alert.msg.split('\n')" :key="p" v-html="p.trim()"></p>
            </div>
            <v-btn dark flat @click="alert.show = false">关闭</v-btn>
          </v-snackbar>
          <v-snackbar class="global-loading" v-model="loading.show" right bottom :timeout="0" color="secondary">
            <div>
              <v-progress-circular indeterminate color="white" :size="20" />
              <span class="msg">{{ loading.msg }}</span>
            </div>
          </v-snackbar>
          <router-view></router-view>
        </v-container>
        <div class="px-3 py-3" style="text-align: center; width: 100%">
          <v-divider></v-divider>
          <p class="grey--text text--darken-2 px-1 py-0 my-0 mt-3">
            &copy;2025 - {{ tenant.copyrights || company }}&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/"
              target="_blank" style="color: #616161; text-decoration: none">{{ tenant.icp || icp }}</a>
            <span class="ver" @click="iconView">最近更新: {{ version }}</span>
          </p>
        </div>
      </v-layout>
    </v-content>
    <v-navigation-drawer width="400" class="rightDrawer" v-model="rightDrawer" stateless app right>
      <div v-if="notificationShow">
        <h3>
          我的通知<v-icon @click="closeRightDrawer" style="cursor: pointer; float: right">close</v-icon>
        </h3>
        <v-divider />
        <notifications />
      </div>
      <div v-if="myTaskShow">
        <h3>
          异步任务<v-icon @click="closeRightDrawer" style="cursor: pointer; float: right">close</v-icon>
        </h3>
        <v-divider />
        <lazy-tasks />
      </div>
      <div v-if="regionInit && regionShow">
        <h3>行政区划编码表<v-icon @click="closeRightDrawer" style="cursor: pointer; float: right">close</v-icon></h3>
        <v-divider />
        <tree :cfg="regionTree" />
      </div>
    </v-navigation-drawer>
  </v-app>
</template>
<script>
import Vue from "vue";
import { Tree } from "javaee-fre";
import { independentRegionTree } from "../routers/comm-func.js";
//----收藏资源的全局接口注入------
Vue.prototype.$favorite = function (type, id) {
  let self = this;
  self.$axios.get(`/home/my/favorite/add/${type}/${id}`).then(() => {
    self.$status("收藏成功！", "success");
  });
};
//-----------------------------
//const IconView = () => import("./icon-view.vue");
//----注册CC视频播放器组件--------
const CcVideoViewer = () => import("../components/cc-video-viewer.vue");
const CoursewareView = () => import("./courseware-view.vue");
const QuestionView = () => import("./question-view.vue");
const PaperView = () => import("./paper-view.vue");
const ExerciseView = () => import("./exercise-view.vue");
const ArticleView = () => import("./article-view.vue");
const ClazzRuleView = () => import("./clazzrule-view.vue");
const StuClazzView = () => import("./stuclazz-view.vue");
const CoursewareMediasView = () => import("./courseware-medias-view.vue");
const Notifications = () => import("./notifications.vue");
const LazyTasks = () => import("./lazy-tasks.vue");

// const DialogConfirmCheckBox = () =>
//   import("../components/dialog-confirm-checkbox.vue");
const CacheManager = () => import("./cache-manager.vue");

Vue.component("cc-video-viewer", CcVideoViewer);
Vue.component("courseware-view", CoursewareView);
Vue.component("article-view", ArticleView);
Vue.component("question-view", QuestionView);
Vue.component("paper-view", PaperView);
Vue.component("exercise-view", ExerciseView);
Vue.component("clazzrule-view", ClazzRuleView);
Vue.component("stuclazz-view", StuClazzView);
Vue.component("courseware-medias-view", CoursewareMediasView);
Vue.component("notifications", Notifications);
Vue.component("lazy-tasks", LazyTasks);
//-----------------------------

export default {
  name: "admin-console",
  props: {},
  components: {
    "tree": Tree
  },
  data() {
    return {
      sGroup: null,
      avatarUrl: null,
      drawerMini: false,
      menus: [],
      appname: this.$const.appName,
      slogan: this.$const.slogan,
      company: this.$const.company,
      icp: this.$const.icp,
      version: this.$const.version,
      moreOrgs: null,
      favorite: { media: 0, courseware: 0, question: 0, paper: 0, article: 0 },
      breadcrumbs: [],
      accOnlineCount: -1,
      rightDrawer: false,
      notificationShow: false,
      myTaskShow: false,
      regionShow: false,
      regionTree: independentRegionTree(),
      regionInit: false,
    };
  },
  watch: {
    $route() {
      this.parseNav();
    },
    account() {
      this.initMenu();
    },
    rightDrawerState(n) {
      if (n) {
        this.showRightDrawer(n);
      }
    },
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
    rightDrawerState() {
      return this.$store.state.rightDrawer;
    },
    account() {
      return this.$store.state.account;
    },
    isSuperMan() {
      return this.$isSuperman();
    },
    tenant() {
      return this.$store.state.tenant;
    },
    tid() {
      let { tid } = this.$query();
      return tid;
    },
    loading() {
      return this.$store.state.loading;
    },
    notificationCount() {
      return this.$store.state.notificationCount;
    },
  },
  methods: {
    iconView() {//帮助浏览系统支持的所有icon
      //this.$dialog.component('图标浏览', IconView, { fullscreen: true });
    },
    myTask() {
      this.showRightDrawer("myTaskShow");
    },
    regionBrowse() {
      this.showRightDrawer("regionShow");
    },
    closeRightDrawer() {
      this.rightDrawer = false;
      let arrs = ["notificationShow", "regionShow", "myTaskShow"];
      for (let a of arrs) {
        this[a] = false;
      }
    },
    showRightDrawer(who) {
      this.$store.commit('rightDrawer', null);
      let arrs = ["notificationShow", "regionShow", "myTaskShow"];
      for (let a of arrs) {
        if (who != a) {
          this[a] = false;
        }
      }
      if (who == "regionShow") {
        if (!this.regionInit) {
          this.regionInit = true;
        }
      }

      this[who] = true;
      this.rightDrawer = true;
    },
    clearCache() {
      let self = this;
      self.$dialog.component("清除缓存", CacheManager, { width: 800 });
    },
    showExceptionAcc() {
      this.$router.push("/console/home/admin/my/tenant/ex_stu");
    },
    refreshAccOnlineCount() {
      let self = this;
      self.$axios.get("/home/my/tenant/acc/online/c").then((r) => {
        self.accOnlineCount = r.data.message;
      });
    },
    changeToSuper() {
      let self = this;
      self.$axios.get("/home/admin/sys/tenant/change/to/0").then((r) => {
        if (r.data && r.data.status == "ok") {
          window.location =
            "/s/a/index.html" + (self.tid ? `?tid=${self.tid}` : "");
        } else {
          self.$status(r.data.message || "切换不成功～", "error");
        }
      });
    },
    changeOrg(id) {
      let self = this;
      self.$axios.get(`/home/my/tenant/org/change/${id}`).then((r) => {
        if (r.data && r.data.status == "ok") {
          window.location =
            "/s/a/index.html" + (self.tid ? `?tid=${self.tid}` : "");
        }
      });
    },
    myFavorite() {
      this.$router.push("/console/home/my/favorite");
    },
    myAccount() {
      this.$router.push("/console/home/my/a");
    },
    logout(clear) {
      if (clear === true) {
        if (typeof localStorage === "object") {
          localStorage.removeItem("__token");
        }
      }
      this.$axios.get("/logout").then((r) => {
        if (!r) {
          return;
        }
        this.$router.push("/login");
      });
    },
    /* 通过权限初始化菜单 */
    initMenu() {
      let self = this,
        acc = self.account;
      if (acc && acc.id) {
        self.avatarUrl = self.$const.baseUrl + "/home/my/a/head.png";
        let map = {},
          roles = acc.roles,
          m = [];

        for (let r of roles) {
          map[r.id] = r;
        }

        self.roles = map;

        if (map["ROLE_TENANT_SUPER"] || map["ROLE_CHG_ORG"]) {
          self.$axios.get("/home/my/tenant/org/children").then((r) => {
            if (r.data && r.data.status == "ok") {
              self.moreOrgs = r.data.message;
            }
          });
        }

        for (let link of self.$const.links) {
          if (
            !link.c ||
            (link.t == "TENANT" && acc.tenantId == 0) ||
            (link.t == "SYS" && acc.tenantId != 0) ||
            (link.disabled &&
              (typeof link.disabled == "function"
                ? link.disabled.apply(self)
                : true))
          ) {
            continue;
          }
          let am = { ...link },
            sm = [];
          for (let asm of am.c) {
            //针对收费模式（纯用户支付直接去掉两个菜单
            if (
              asm.disabled &&
              (typeof asm.disabled == "function"
                ? asm.disabled.apply(self)
                : true)
            ) {
              continue;
            }
            let canAccess = !asm.r;
            if (!canAccess) {
              let tmpRoles = asm.r.split(",");
              for (var tmpR of tmpRoles) {
                if (map["ROLE_" + tmpR]) {
                  canAccess = true;
                  break;
                }
              }
            }
            if (canAccess) {
              let smc = { ...asm };
              if (!smc.i) {
                smc.i = "subdirectory_arrow_right";
              }
              if (smc.url) {
                smc.url = `/console/${smc.url}`;
              }
              sm.push(smc);
            }
          }
          if (sm.length > 0) {
            am.sel = false;
            am.c = sm;
            m.push(am);
          }
        }
        self.menus = m;
        let hash = window.location.hash;
        if (hash.indexOf("#/console/") != 0) {
          self.$router.push(m[0].c[0].url);
        }
        self.parseNav();
      }
    },
    parseNav() {
      /* 处理导航和面包屑 */
      let self = this,
        menus = self.menus,
        path = self.$route.path,
        menu,
        menuIdx,
        subMenu;
      if (!menus) {
        return;
      }
      for (let mi in menus) {
        let m = menus[mi];
        for (let smi in m.c) {
          let sm = m.c[smi],
            idx = path.indexOf(sm.url);

          if (
            idx == 0 &&
            (path.length == sm.url.length || path.charAt(sm.url.length) == "/")
          ) {
            menu = m;
            menuIdx = mi;
            subMenu = sm;
            break;
          }
        }
      }

      let breadcrumbs = [];

      if (menu) {
        menu.sel = true;
        self.$set(menus, menuIdx, menu);

        breadcrumbs.push(
          ...[{ text: menu.l }, { text: subMenu.l, link: subMenu.url }]
        );

        let matched = self.$route.matched;

        let idx = matched.findIndex((m) => m.path == subMenu.url);

        if (idx != -1) {
          for (let i = idx + 1; i < matched.length; i++) {
            let mnode = matched[i],
              meta =
                typeof mnode.meta == "function"
                  ? mnode.meta.apply(self)
                  : mnode.meta,
              name = meta.name;
            if (self.$router._lastTitle && i == matched.length - 1) {
              name = self.$router._lastTitle;
            }
            breadcrumbs.push({
              text: name,
              link: mnode.path,
            });
          }
        }
      } else {
        let matched = self.$route.matched;
        for (let m of matched) {
          let meta = typeof m.meta == "function" ? m.meta.apply(self) : m.meta,
            title = meta.name;
          if (title) {
            breadcrumbs.push({ text: title });
          }
        }
      }
      if (breadcrumbs.length > 0) {
        breadcrumbs[breadcrumbs.length - 1].disabled = true;
      }

      if (!self.breadcrumbs) {
        self.breadcrumbs = breadcrumbs;
      } else {
        for (let i in breadcrumbs) {
          if (self.breadcrumbs.length <= i) {
            self.breadcrumbs.push(breadcrumbs[i]);
          } else {
            //如果link不一样替换，如果link一样不用管
            let bc = self.breadcrumbs[i], nbc = breadcrumbs[i];
            if (!bc.link || bc.link != nbc.link) {
              self.$set(self.breadcrumbs, i, nbc);
            } else {
              bc.disabled = nbc.disabled;
              self.$set(self.breadcrumbs, i, bc);
            }
          }
        }
        if (self.breadcrumbs.length > breadcrumbs.length) {
          self.breadcrumbs.splice(breadcrumbs.length);
        }
      }
    },
    searchResource(type) {
      let self = this;
      switch (type) {
        case 1:
          self.$router.push("/console/home/my/media");
          break;
        case 2:
          self.$router.push("/console/home/my/courseware");
          break;
        case 3:
          self.$router.push("/console/home/my/question");
          break;
        case 4:
          self.$router.push("/console/home/my/paper");
          break;
        case 5:
          self.$router.push("/console/home/my/article");
          break;
        case 6:
          self.$router.push("/console/home/my/crule");
          break;
      }
    },
  },
  created() {
    let self = this;
    self.initMenu();
    //判断是否主动关闭过安全培训提醒，如果没有，获取服务器端的领域，并判断是否有安全培训领域并提醒
    let a = self.$store.state.account;
    if (!a || !a.id) {
      return;
    }

    if (a.type == 1) {
      let isTenantSuper = self.$isInRole("ROLE_TENANT_SUPER");
      if (
        isTenantSuper ||
        self.$isSuperman() ||
        self.$isInRole("ROLE_TENANT_STU")
      ) {
        self.refreshAccOnlineCount();
      }

      if (isTenantSuper || self.$isInRole("ROLE_TENANT_STU_EX")) {
        //异常用户的一次检测
        self.$axios.get("/home/admin/my/tenant/stu/except/count").then((r) => {
          if (r.data && r.data.status == "ok" && r.data.message > 0) {
            self.$notify(
              `敬告：系统检测到<b>${r.data.message}</b>人具有翻拍照片、代刷学时等作弊行为，请各企业及时关注学员学习数据，给予问题学员警告教育，并对产生的学习数据合理使用，合规合法履行企业安全培训主体责任。如有其他疑问，请联系专门对接的服务人员。`,
              function () {
                self.$router.push("/console/home/admin/my/tenant/ex_stu");
              }
            );
          }
        });
      }
      //如果开展安全培训业务，提醒一下培训信息的要求.
      if (a.tenantId != 0) {
        // self.$axios.get("/home/my/tenant/domain/list").then((r) => {
        //   if (
        //     r.data &&
        //     r.data.status == "ok" &&
        //     r.data.message &&
        //     r.data.message.findIndex((m) => m.code == "anquan") >= 0
        //   ) {
        //     setTimeout(() => {
        //       self.$notify(
        //         "友情提示：道路运输企业安全教育培训应当每月不少于1次，每次不少于2学时（特别管控危险化学品道路运输企业不少于3学时）。"
        //       );
        //     }, 1000);
        //   }
        // });
        self.$axios.get("/home/my/notice/summary").then((r) => {
          if (r.data.status != "ok") {
            return;
          }
          r = r.data.message;
          let total = 0,
            unRead = 0;
          if (r.sc) {
            total += r.sc[0] + r.sc[1];
            unRead += r.sc[0];
          }

          if (r.mc) {
            total += r.mc[0] + r.mc[1];
            unRead += r.mc[0];
          }

          if (r.oc) {
            total += r.oc[0] + r.oc[1];
            unRead += r.oc[0];
          }

          self.$store.commit("notificationCount", {
            total: total,
            unRead: unRead,
          });
        });
      }
    }

    // let passAlert = null,
    //   pk = null,
    //   lStore = typeof localStorage === "object" ? localStorage : null;
    // if (!a.pwdComplex) {
    //   pk = "_pwd_complext";
    //   if (!lStore || !lStore.getItem(pk)) {
    //     passAlert = "您的密码强度不够，为了安全请及时修改密码~";
    //   }
    // } else if (a.pwdExpired) {
    //   pk = "_pwd_expired";
    //   if (!lStore || !lStore.getItem(pk)) {
    //     passAlert = "您的密码已很久没有修改了，为了安全请及时修改密码~";
    //   }
    // }
    // if (passAlert) {
    //   self.$dialog.component(
    //     "安全提醒",
    //     DialogConfirmCheckBox,
    //     {
    //       text: passAlert,
    //       icon: "info",
    //       iconColor: "red",
    //       width: 400,
    //       onBoxCheck(c) {
    //         if (c && lStore) {
    //           lStore.setItem(pk, true);
    //         }
    //       },
    //     },
    //     [
    //       {
    //         label: "确认",
    //         color: "primary",
    //         func() {
    //           self.$router.push("/console/home/my/a");
    //         },
    //       },
    //     ]
    //   );
    // }
  },
  beforeMount() {
    this.$status(); //清空一下状态栏.
  },
};
</script>
<style>
img.logo {
  height: 30px;
  width: auto;
  display: inline-flex;
}

.admin-admin .group .v-list__tile {
  padding: 0;
}

.admin-admin .group-item .v-list__tile {
  padding-left: 40px;
}

.user-avatar {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.origin-select {
  cursor: pointer;
  display: flex;
  align-items: center;
}

#main-container {
  min-height: 500px;
  padding: 0 25px;
}

.main-content {
  background: #fff;
}

.main-content .breadcrumbs-container {
  padding: 10px 25px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.main-content .breadcrumbs-container .v-breadcrumbs {
  padding: 0;
  margin-right: 20px;
}

.main-content .breadcrumbs-container .back-link {
  color: #aaa;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
}

.main-content .breadcrumbs-container .back-link i.v-icon {
  color: #aaa;
  font-size: 16px;
}

.status p {
  margin-bottom: 0px;
}

.alert-msg {
  margin-bottom: 8px;
}

.global-loading .msg {
  padding: 8px;
}

.top-acts {
  margin-left: 16px;
  font-size: 13px;
  cursor: pointer;
}

.top-acts .v-icon {
  margin-right: 4px;
}

.acc-online-count b {
  color: lawngreen;
}

.exception-acc-count b,
.my-notifications b {
  color: orange;
}

.sys-alert {
  color: orange;
  border: 1px solid orange;
  padding: 16px;
  border-radius: 4px;
  margin: 8px 0;
}

.sys-info {
  color: #0068b7;
  border: 1px solid #0068b7;
  padding: 16px;
  border-radius: 4px;
  margin: 8px 0;
}

.row-warning {
  color: red !important;
}

.rightDrawer {
  padding: 16px;
}

.ver {
  padding: 8px;
}
</style>
